import React from "react";
import "./designersGrid.scss";

export const DesignersGrid: React.FC = ({ children }) => {
  return <div className="choosePlan-designers__wrapper">{children}</div>;
};
